import '@linktivity/link-styles';
import App from '@nankai/online/App';
import '@nankai/online/i18n';
import '@nankai/online/styles/index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
